import React from "react";
import styled from "styled-components";

const StyledButton = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: ${p => p.gap || "0.5rem"};

    color: ${p => p.color || "transparent"};
    border: ${p => p.border || "none"};
    border-radius: ${p => p.borderRadius || "8px"};
    outline: none;
    background-color: ${p => p.backgroundColor || "transparent"};
    padding: ${p => p.padding || "0 1rem"};
    font-size: ${p => p.size || "0.875rem"};
    margin-top: ${p => p.marginTop};
    margin-left: ${p => p.marginLeft};
    margin-right: ${p => p.marginRight};
    margin-bottom: ${p => p.marginBottom};
    white-space: nowrap;
    width: ${p => p.width};
    min-width: ${p => p.minWidth};
    height: ${p => p.height || "42px"};
    min-height: ${p => p.minHeight || "42px"};
    box-sizing: border-box;
    font-family: ${p => p.family || "Manrope, Helvetica, sans-serif"};
    font-weight: ${p => p.weight || 700};
    cursor: ${p => p.disabled ? "not-allowed" : p.cursor || "pointer"};
    box-shadow: ${p => p.boxShadow || "none"};
    opacity: ${p => p.disabled ? 0.65 : 1};
    transition: transform 0.16s ease, background 0.16s ease, border-color 0.16s ease, box-shadow 0.16s ease, opacity 0.16s ease;

    &:hover:not(:disabled) {
        transform: translateY(-1px);
        box-shadow: ${p => p.hoverBoxShadow || p.boxShadow || "0 10px 22px rgba(23, 26, 34, 0.12)"};
    }

    &:active:not(:disabled) {
        transform: translateY(0);
    }

    &:focus-visible {
        outline: 2px solid #171a22;
        outline-offset: 2px;
    }

    @media (prefers-reduced-motion: reduce) {
        transition: none;

        &:hover:not(:disabled),
        &:active:not(:disabled) {
            transform: none;
        }
    }
`;

export const ActivateFeatureButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: ${p => p.gap || "0.5rem"};
    width: ${p => p.width || "140px"};
    min-width: ${p => p.minWidth};
    height: ${p => p.height || "42px"};
    min-height: ${p => p.minHeight || "42px"};
    padding: ${p => p.padding || "0 1rem"};
    box-sizing: border-box;
    border: ${p => p.border || "1px solid var(--calendar-action-primary-bg, #5B6EF5)"};
    border-radius: ${p => p.borderRadius || "8px"};
    background-color: ${p => p.backgroundColor || "var(--calendar-action-primary-bg, #5B6EF5)"};
    color: ${p => p.color || "var(--calendar-action-primary-text, #FFFFFF)"};
    font-family: Manrope, Helvetica, sans-serif;
    font-size: 14px;
    font-weight: ${p => p.weight || 700};
    line-height: 1.2;
    text-align: center;
    white-space: nowrap;
    cursor: ${p => p.disabled ? "not-allowed" : p.cursor || "pointer"};
    opacity: ${p => p.disabled ? 0.65 : 1};
    box-shadow: ${p => p.boxShadow || "none"};
    transition: transform 0.16s ease, background 0.16s ease, border-color 0.16s ease, box-shadow 0.16s ease, opacity 0.16s ease;

    &:hover:not(:disabled) {
        transform: translateY(-1px);
        box-shadow: ${p => p.hoverBoxShadow || "0 10px 22px rgba(91, 110, 245, 0.18)"};
    }

    &:active:not(:disabled) {
        transform: translateY(0);
    }

    &:focus-visible {
        outline: 2px solid #171A22;
        outline-offset: 2px;
    }

    img {
        flex: 0 0 auto;
    }

    @media (prefers-reduced-motion: reduce) {
        transition: none;

        &:hover:not(:disabled),
        &:active:not(:disabled) {
            transform: none;
        }
    }
`;

function Button(props) {
    const { children, ...styleProps } = props;
    return (
        <StyledButton {...styleProps} >
            {children}
        </StyledButton>
    );
}

export default Button;
